import type {
  activityInfo,
  pageBase,
  pageInfo,
  activityDetail,
  taskDetail,
  rewardListItem,
  taskCheckRes,
  rewardClaimRes,
  RankDTO,
  InviteCode,
  ShortLinkRes,
} from '@/types';
import { get, post, WalletType } from '@web3/base-utils';
export interface ActivityListParams extends pageBase {
  activityTag?: number;
  activityStatus?: number;
}

export interface RewardListParams extends pageBase {
  walletAddress?: string;
  walletType?: number;
  walletId?: string;
  chainId: number;
}

export interface TaskListParams {
  activityId: number;
  taskType?: number | number[];
  chainId?: number;
  excludeTaskType?: number | number[];
  walletAddress?: string;
  walletType?: WalletType;
  walletId?: string;
}

export interface ListResult<T> {
  dataList: T[];
  pageInfo: pageInfo;
}

export interface socialMediaParams {
  accessToken: string;
  recordId?: number | undefined;
  socialMediaId: string;
  socialMediaName?: string;
  socialMediaType?: number;
  taskId: number | undefined;
  chainId?: number;
  walletAddress?: string;
  walletType?: WalletType;
  walletId?: string;
}

export type RewardEligibilityRes = {
  hasPendingRewards: boolean;
  rewardsCount: number;
};

const baseApiUrl = 'spot/api/web3/content/ada/';

/**
 * AirDrop-活动列表 Featured
 * @param data
 * @returns
 */
export const getFeaturedActivityList = (data?: ActivityListParams) => {
  return get<ListResult<activityInfo>>(
    `${baseApiUrl}activity/list/featured`,
    data
  );
};
/**
 * AirDrop-活动列表 Ended
 * @param data
 * @returns
 */
export const getEndedActivityList = (data?: ActivityListParams) => {
  return get<ListResult<activityInfo>>(
    `${baseApiUrl}activity/list/ended`,
    data
  );
};
/**
 * AirDrop-活动列表 Daily
 * @param data
 * @returns
 */
export const getDailyActivityList = (data?: ActivityListParams) => {
  return get<ListResult<activityInfo>>(
    `${baseApiUrl}activity/list/daily`,
    data
  );
};
/**
 * AirDrop-活动列表(旧)
 * @param data
 * @returns
 */
export const getActivityList = (data?: ActivityListParams) => {
  return get<ListResult<activityInfo>>(`${baseApiUrl}activity/list`, data);
};
/**
 * AirDrop-查询活动详情
 * @param data
 * @returns
 */
export const getActivityDetail = (data?: RequestData) => {
  return get<activityDetail>(`${baseApiUrl}activity/details`, data);
};
/**
 * AirDrop-任务列表
 * @param data
 * @returns
 */
export const getTaskList = (data?: RequestData) => {
  return get<taskDetail[]>(`${baseApiUrl}v2/task/list`, data);
};

/**
 * AirDrop-奖励列表
 * @param data
 * @returns
 */
export const getRewardList = (data?: RequestData) => {
  return get<ListResult<rewardListItem>>(`${baseApiUrl}v2/reward/list`, data);
};

/**
 * AirDrop-奖励列表
 * @param data
 * @returns
 */
export const getRewardEligibility = (
  data?: RequestData & { activityId?: number }
) => {
  return get<RewardEligibilityRes>(`${baseApiUrl}reward/eligibility`, data);
};
/**
 * AirDrop-领取奖励
 * @param data
 * @returns
 */
export const rewardClaim = (data?: RequestData) => {
  return post<rewardClaimRes>(`${baseApiUrl}v2/reward/claim`, data);
};
/**
 * AirDrop-任务验证
 * @param data
 * @returns
 */
export const taskCheck = (data?: RequestData) => {
  return post<taskCheckRes>(`${baseApiUrl}task/check`, data);
};
/**
 * AirDrop-领取活动任务
 * @param data
 * @returns
 */
export const activityApply = (data?: RequestData) => {
  return post(`${baseApiUrl}v2/activity/apply`, data);
};
/**
 * AirDrop-提交社媒信息
 * @param data
 * @returns
 */
export const saveSocialMedia = (data?: RequestData) => {
  return post(`${baseApiUrl}task/save-social-media`, data);
};

/**
 * AirDrop-排行榜
 * @param data
 * @returns
 */

interface RankListParams {
  activityId?: string;
}

interface RankList {
  rankingList: RankDTO[];
  userRankingDTO: RankDTO;
}

export const getRankList = (data?: RankListParams) => {
  return get<RankList>(`${baseApiUrl}activity/ranking-list`, data);
};

export const getInviteCode = () => {
  return get<{ data: InviteCode }>(`/s1/code/info-msg`);
};

/**
 * AirDrop-分享短链 /web3/wallet/v1/public/shortlink?originalUrl=http://www.bybit.com&expiredTime=1710979200000&publicNetwork=1&foreverLink=0
 * @param data
 * @returns
 */
export interface ShortLinkParam {
  originalUrl: string;
  expiredTime?: number;
  publicNetwork?: number;
  foreverLink?: number;
}
export const getShortLink = (params: ShortLinkParam) => {
  return get<ShortLinkRes>(`/web3/wallet/v1/public/shortlink`, params);
};

/**
 * AirDrop-report点击类型子任务
 * @param data
 * @returns
 */
export const reportTask = (data) => {
  return post(`${baseApiUrl}task/report`, data);
};

export const getInviteCode2 = () => {
  return get<{ data: Array<InviteCode> }>(`/s1/code/info-msg?scene=2`);
};
export interface ActionsRes {
  icon?: string;
  title?: string;
  description?: string;
  label?: string;
  disabled?: boolean;
  iconIndex?: number;
}
export const getActionsMetadata = (params: {
  actionId: number;
  iconIndex?: number;
}) => {
  return get<ActionsRes>(
    `/spot/api/web3/content/airdrop/actions/metadata`,
    params
  );
};
